import {graphSpec, WebInsights} from './types';
import {PolarisStartChatOptionsVm} from '../../services/polaris/model';
import {PolarisCitation} from '../../services/polaris/model';
import {ChatLibraryApiResponse} from './chat-library/models/chat-library.models';

export interface ChatMessage {
    id: string;
    author: ChatMessageAuthor;
    content: string;
    graphs?: graphSpec[];
    timestamp: number;
    followUpQuestions?: string[];
    error?: string;
    insights?: string;
    citations?: PolarisCitation[];
    webInsights?: WebInsights | string;
    creativesURLs?: string[];
    chatLibrary?: ChatLibraryApiResponse;
    interactionId?: string;
    userResponse?: UserMessageResponse;
    origin?: PolarisOrigin;
    widgetName?: string;
}

export enum ChatMessageAuthor {
    USER = 'user',
    ASSISTANT = 'assistant'
}

export enum UserMessageResponse {
    POSITIVE = 'positive',
    NEGATIVE = 'negative'
}

export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export const POLARIS_NAME = 'POLARIS™';

export type PolarisOrigin = 'polaris_homepage' | 'alert_view_page' | 'polaris_wizard' | 'widget' | 'signals_screen';

export interface WizardSubmitEvent {
  message: string;
  options: PolarisStartChatOptionsVm;
  brand: string | null;
  competitors: string[];
}
